// extracted by mini-css-extract-plugin
export var quantityInput = "_fs-0";